"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModalContext", {
  enumerable: true,
  get: function get() {
    return _context.default;
  }
});
Object.defineProperty(exports, "withModal", {
  enumerable: true,
  get: function get() {
    return _withModal.default;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Button = _interopRequireDefault(require("../Button"));

var _Container = _interopRequireDefault(require("../Container"));

var _Portal = _interopRequireDefault(require("../Portal"));

require("./styles.css");

var _Header = _interopRequireDefault(require("../Header"));

var _Row = _interopRequireDefault(require("../Row"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants = require("../../constants");

var _context = _interopRequireDefault(require("./context"));

var _Controller = _interopRequireDefault(require("./Controller"));

var _Controlled = _interopRequireDefault(require("./Controlled"));

var _withModal = _interopRequireDefault(require("./withModal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = ['small', 'medium', 'large'];

var Modal =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      var closeOnEsc = _this.props.closeOnEsc;

      if (closeOnEsc && e.keyCode === _constants.KEY_ESCAPE) {
        var current = _this.wrapperRef.current; // NOTE: might have issue with this checking in the future

        if (current && current.parentNode && current.parentNode.lastChild === current) {
          _this.dismiss();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "show", function () {
      var visible = _this.state.visible;

      if (!visible) {
        _this.setState({
          visible: true
        }, function () {
          _this.handleOnOpen();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      var visible = _this.state.visible;

      if (visible) {
        _this.setState({
          visible: false
        }, function () {
          _this.handleOnClose();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Modal.className];
      (0, _lib.addClassByPropName)(names, _this.props, ['dimOverlay', 'dimOverlayClickable']);
      (0, _lib.addClassByPropName)(names, _this.state, ['visible']);
      var size = _this.props.size;

      if (size && sizes.some(function (s) {
        return s === size;
      })) {
        (0, _lib.addClassName)(names, size);
      }

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "contentClassNames", function () {
      var names = [Modal.contentClassName];
      (0, _lib.addClassByPropName)(names, _this.props, [], 'contentClassName');
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMount", function () {
      return _this.handleUpdateDocumentBody();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnUnmount", function () {
      document.body.classList.remove(Modal.fixedScrollClassName);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function () {
      var onOpen = _this.props.onOpen;

      if (onOpen) {
        onOpen();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function () {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateDocumentBody", function () {
      var bodyScrollable = _this.props.bodyScrollable;

      if (!bodyScrollable) {
        var visible = _this.state.visible;

        if (visible) {
          document.body.classList.add(Modal.fixedScrollClassName);
        } else {
          document.body.classList.remove(Modal.fixedScrollClassName);
        }
      } else {
        document.body.classList.remove(Modal.fixedScrollClassName);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleIgnoreClick", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props = _this.props,
          headerNode = _this$props.headerNode,
          headerContent = _this$props.headerContent,
          showCloseButton = _this$props.showCloseButton;
      var className = 'header';
      return (0, _lib.getRenderProps)(headerNode, {
        headerContent: headerContent,
        showCloseButton: showCloseButton,
        className: className,
        close: _this.dismiss
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var children = _this.props.children;
      return (0, _lib.getRenderProps)(children, {
        close: _this.dismiss
      });
    });

    var _visible = props.visible;
    _this.state = {
      prevProps: {
        visible: _visible
      },
      visible: _visible
    };
    _this.wrapperRef = _react.default.createRef();
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var closeOnEsc = this.props.closeOnEsc;

      if (closeOnEsc) {
        window.addEventListener('keydown', this.handleCheckClose);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var visible = this.props.visible;

      if (prevProps.visible !== visible) {
        if (visible) {
          this.handleOnOpen();
        } else {
          this.handleOnClose();
        }
      }

      var stateVisible = this.state.visible;

      if (stateVisible !== prevState.visible) {
        this.handleUpdateDocumentBody();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var closeOnEsc = this.props.closeOnEsc;

      if (closeOnEsc) {
        window.removeEventListener('keydown', this.handleCheckClose);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as,
          wrapperRef = _this$props2.wrapperRef,
          children = _this$props2.children,
          onClick = _this$props2.onClick,
          onOpen = _this$props2.onOpen,
          onClose = _this$props2.onClose,
          contentClassName = _this$props2.contentClassName,
          closeOnEsc = _this$props2.closeOnEsc,
          propsVisible = _this$props2.visible,
          dimOverlay = _this$props2.dimOverlay,
          dimOverlayClickable = _this$props2.dimOverlayClickable,
          bodyScrollable = _this$props2.bodyScrollable,
          headerNode = _this$props2.headerNode,
          headerContent = _this$props2.headerContent,
          showCloseButton = _this$props2.showCloseButton,
          size = _this$props2.size,
          rest = _objectWithoutProperties(_this$props2, ["as", "wrapperRef", "children", "onClick", "onOpen", "onClose", "contentClassName", "closeOnEsc", "visible", "dimOverlay", "dimOverlayClickable", "bodyScrollable", "headerNode", "headerContent", "showCloseButton", "size"]);

      var visible = this.state.visible;
      var classNames = this.classNames();
      var contentClassNames = this.contentClassNames();
      var Wrapper = (0, _lib.getElementType)(this, this.props);

      if (visible) {
        return _react.default.createElement(_Portal.default, {
          onMount: this.handleOnMount,
          onUnmount: this.handleOnUnmount
        }, _react.default.createElement("div", {
          role: "presentation",
          ref: this.wrapperRef,
          className: classNames,
          onClick: dimOverlay && dimOverlayClickable ? this.dismiss : null
        }, _react.default.createElement(Wrapper, _extends({}, rest, {
          ref: wrapperRef,
          className: contentClassNames,
          onClick: this.handleIgnoreClick
        }), this.renderHeader(), this.renderContent())));
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var visible = props.visible;
      return {
        // Store the previous props in state
        prevProps: {
          visible: visible
        },
        visible: prevProps.visible !== visible ? visible : state.visible
      };
    }
  }]);

  return Modal;
}(_react.PureComponent);

exports.default = Modal;

_defineProperty(Modal, "Controller", _Controller.default);

_defineProperty(Modal, "Controlled", _Controlled.default);

_defineProperty(Modal, "Consumer", _context.default.Consumer);

_defineProperty(Modal, "className", 'MHub-Modal');

_defineProperty(Modal, "contentClassName", 'MHub-Modal-Content');

_defineProperty(Modal, "fixedScrollClassName", 'MHub-fixed-scroll');

_defineProperty(Modal, "displayName", 'Modal');

_defineProperty(Modal, "propTypes", {
  as: _common.customPropTypes.as,
  visible: _propTypes.default.bool,
  children: _common.customPropTypes.render.isRequired,
  onClick: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  dimOverlay: _propTypes.default.bool,
  dimOverlayClickable: _propTypes.default.bool,
  contentClassName: _propTypes.default.string,
  bodyScrollable: _propTypes.default.bool,
  showCloseButton: _propTypes.default.bool,
  closeOnEsc: _propTypes.default.bool,
  headerContent: _propTypes.default.string,
  headerNode: _common.customPropTypes.render,
  size: _propTypes.default.oneOf(sizes),
  wrapperRef: _common.customPropTypes.ref
});

_defineProperty(Modal, "defaultProps", {
  as: _Container.default,
  visible: false,
  onClick: null,
  onOpen: null,
  onClose: null,
  dimOverlay: true,
  dimOverlayClickable: true,
  contentClassName: null,
  bodyScrollable: false,
  showCloseButton: true,
  closeOnEsc: true,
  headerContent: null,
  headerNode: function headerNode(_ref) {
    var showCloseButton = _ref.showCloseButton,
        headerContent = _ref.headerContent,
        className = _ref.className,
        close = _ref.close;
    return _react.default.createElement(_Row.default, {
      className: className,
      between: !!headerContent,
      end: !headerContent,
      middle: true
    }, headerContent ? _react.default.createElement(_Header.default, {
      upperCase: true
    }, headerContent) : null, showCloseButton ? _react.default.createElement(_Button.default, {
      icon: _react.default.createElement(_Icon.default, {
        name: _Icon.default.Close
      }),
      className: "close",
      basic: true,
      color: "blue",
      onClick: close
    }) : null);
  },
  size: 'small',
  wrapperRef: null
});